import { Browser, DeviceInfoDefaults } from '../deviceInfoTypes';

export function getBrowser(ua: NavigatorID['userAgent']): Browser {
  const browser = {
    ...DeviceInfoDefaults.browser,
    IS_CHROME: /CriOS/.test(ua), // Temporary only mobile chrome is detected. TODO: Implement desktop chrome detection
  };

  return browser;
}
